import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TopHeader from '../../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { PvMonitoringContext } from '../../../../../context/PvMonitoringContext';
import { PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';


import Tab1ChartData from './tab1Inverter1/tab1Inverter1Chart/Tab1ChartData';
import Tab2Inverter1Log from './tab2Inverter1/tab2Inverter1Log/Tab2Inverter1Log';
import EnergyMeterTab2 from '../../energy_meter/energy_meterTabs/Energy_meterTab2/EnergyMeterTab2';
import Tab3Inverter1 from './tab3Inverter1/Tab3Inverter1';
import Tab4Inverter1 from './tab4Inverter1/Tab4Inverter1';
import Tab4Inverter1Data from './tab4Inverter1/tab4Inverter1Data/Tab4Inverter1Data';
import Tab5Inverter1 from './tab5Inverter1/Tab5Inverter1';
import Tab6Inverter1 from './tab6Inverter1/Tab6Inverter1';
import InverterHourlyLog from './InverterHourlyLog/InverterHourlyLog';



export default function Inverter1Tabs({TabTitle,ID}) {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    // const [FromDate, setFromDate] = useState(getDateTimeForTab3().LastDay)
    // const [ToDate, setToDate] = useState(getDateTimeForTab3().Today)

    const [key, setKey] = useState('Chart');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    // console.log("TabtitleTabs", TabTitle, "ID", ID);

   

    return (
        <Box>
            
            <Box mt={spacing(1)}>
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Chart" title="Chart">
                   <Tab1ChartData  TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                    {/* <Tab eventKey="Voltage Profile" title="Voltage Profile">
                    <Tab2Inverter1Log  TabTitle={TabTitle} ID={ID}/>
                    </Tab> */}

                    <Tab eventKey="Log" title="Log">
                    <Tab3Inverter1 TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                    <Tab eventKey="Hourly Log Report" title="Hourly Log Report">
                    <InverterHourlyLog TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                    <Tab eventKey="DC Vs AC Power" title="DC Vs AC Power">
                    <Tab4Inverter1Data TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                    <Tab eventKey="Inverter Performance" title="Inverter Performance">
                    <Tab5Inverter1 TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                   <Tab eventKey="Irradiance Vs AC Power" title="Irradiance Vs AC Power">
                    <Tab6Inverter1 TabTitle={TabTitle} ID={ID}/>
                    </Tab>


                   
                </Tabs>
            </Box>
        </Box>

    )
}